import { RegistrationButtonFooter, ContinueButton, SkipButton } from "#/components/views/register/RegistrationButtons"
import { RegistrationFlowTitle } from "#/components/views/register/RegistrationFlowTitle"
import { RegistrationFlowLayout } from "#/components/views/register/RegistrationLayouts"
import { useTrackView } from "#/utils/heap"
import { Stack, FormControlLabel, Checkbox } from "@carrotfertility/carotene-core"
import React from "react"
import { useIntl, FormattedMessage } from "react-intl"
import {
  RtxConsentInnerContent,
  rtxConsentHeaderMessage,
  rtxConsentCheckboxLabel
} from "#/components/consent/RtxConsentInnerContent"

interface RTXRewardsOptInProps {
  isSubmitting: boolean
  rtxRewardsOptIn: boolean | null
  setRtxRewardsOptIn: (newValue: boolean) => void
  onBack: () => void
  onComplete: (optedIn: boolean) => void
  employeeId: number
}

export function RTXRewardsOptIn({
  isSubmitting,
  rtxRewardsOptIn,
  setRtxRewardsOptIn,
  onBack,
  onComplete,
  employeeId
}: RTXRewardsOptInProps): JSX.Element {
  const intl = useIntl()

  useTrackView("RTXRewardsOptInRegFlow", "RTX Rewards opt in screen")

  const header = intl.formatMessage(rtxConsentHeaderMessage)

  return (
    <>
      <RegistrationFlowTitle title={header} />
      <RegistrationFlowLayout
        header={header}
        description={
          <Stack>
            <RtxConsentInnerContent showHeader={false} />
            <FormControlLabel
              label={<FormattedMessage {...rtxConsentCheckboxLabel} />}
              control={<Checkbox checked={rtxRewardsOptIn} onChange={(e) => setRtxRewardsOptIn(e.target.checked)} />}
            />
          </Stack>
        }
        interactiveElements={
          <RegistrationButtonFooter
            onBack={onBack}
            skipButton={
              <SkipButton onClick={() => onComplete(false)} disabled={isSubmitting}>
                <FormattedMessage defaultMessage="Skip" />
              </SkipButton>
            }
            continueButton={
              <ContinueButton onClick={() => onComplete(true)} disabled={rtxRewardsOptIn !== true || isSubmitting}>
                <FormattedMessage defaultMessage="Continue" />
              </ContinueButton>
            }
          />
        }
        employeeId={employeeId}
      />
    </>
  )
}
